import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-too-many-request-page',
  templateUrl: './too-many-request-page.component.html',
  styleUrl: './too-many-request-page.component.scss'
})
export class TooManyRequestPageComponent {
  constructor(private router: Router) {}

  ngOnInit(): void {
    // Check if "tooManyRequests" flag is stored in sessionStorage
    const tooManyRequests = sessionStorage.getItem('tooManyRequests');

    if (!tooManyRequests) {
      // If no flag is found, navigate back to home page
      this.router.navigate(['/']);
    } else {
      // Remove the flag to prevent unnecessary redirects on future visits
      sessionStorage.removeItem('tooManyRequests');
    }
  }
}
